/* Impression SCDM — L'ONGLET « PERSONNALISE ».  11 septembre 2026.

   A QUOI CA SERT. Au client qui veut JUSTE ECRIRE UN MOT sur une pancarte.
   Pas de logiciel de graphisme : celui qui veut un vrai design a deja deux
   chemins, « Creer un design avec l IA » et « Demander une soumission ».
   Ici, on ecrit un texte, on choisit une police, deux couleurs, une forme et
   une grandeur, on ajoute un pictogramme si on veut, ON VOIT SON DESSIN, ON
   VOIT SON PRIX, et on envoie au configurateur.

   OU IL VIT, ET POURQUOI CA A CHANGE. Jusqu au 11 septembre 2026 l editeur
   vivait dans Contenu > Fichiers, charge par « file_url ». Or Contenu >
   Fichiers est PARTAGE AVEC LE THEME PUBLIE : corriger l editeur la-bas
   changeait le site en ligne dans la seconde. Il est donc devenu un ASSET DU
   THEME, charge par « asset_url » depuis snippets/scdm-minimum.liquid. Une
   seule ligne a change dans ce snippet, et c est la seule.
   L ancienne copie dans Contenu > Fichiers ne sert plus a rien.

   ============================================================
   IL NE CALCULE AUCUN PRIX. JAMAIS.
   ============================================================
   Il appelle window.SCDM.calcul() et il AFFICHE ce qui en sort. Il ne
   contient aucun montant, aucun taux, aucun multiplicateur, aucune regle
   commerciale. Si un jour le prix affiche ici ne correspond plus a celui du
   configurateur, c est que quelqu un a recopie un chiffre : le retirer.

   ============================================================
   LES BORNES NE SONT PAS RECOPIEES ICI NON PLUS.
   ============================================================
   Elles sont lues dans window.SCDM_CUSTOM (assets/scdm-custom.js) :
   MIN_COTE, LARGEUR_MAX, LONGUEUR_MAX, AIRE_MAX, et ses trois messages.
   ATTENTION, une deuxieme table existe : assets/scdm-limites.js borne le
   configurateur en entier et c est ELLE qui bloque l ajout au panier.
   Changer une borne dans un seul des deux fichiers fait afficher un prix que
   le panier refusera ensuite. NE RIEN ECRIRE EN DUR ICI.

   CE QU IL NE CASSE PAS. Aucune ligne de scdm.js, scdm-data.js,
   scdm-panneau.js, scdm-panier-technique.js ni scdm-catalogue.liquid n a ete
   touchee. L editeur parle au configurateur par trois portes publiques
   seulement :

     window.SCDM.calcul()            lire le prix de la ligne
     window.SCDM.valide()            savoir si la configuration passe
     window.SCDM.chargerFichier(f)   deposer le PNG, comme un televersement

   ...plus les champs du formulaire, a qui il envoie un evenement « input »
   ordinaire. Il n ECRIT JAMAIS dans window.SCDM.etat directement : muter
   l etat sans redessiner laisse le configurateur dans un etat incoherent,
   parce que rafraichir() n est pas exposee.

   LE BOUTON DE L ONGLET. Il s accroche a #scdmOnglets, la rangee rendue par
   sections/scdm-catalogue.liquid. Cette rangee est RECONSTRUITE quand les
   3 441 modeles arrivent, et sa fonction rebatirOnglets() remet a la fin
   TOUT BOUTON QUI N A PAS D ATTRIBUT data-filtre.
   >>> NE JAMAIS DONNER data-filtre AU BOUTON « Personnalise ». <<<
   Le jour ou quelqu un le fait pour qu il ressemble aux autres, la rangee
   l effacera et il ne reviendra plus.

   LES PICTOGRAMMES SONT DESSINES ICI, EN TRACES. Ils ne viennent pas du CDN.
   Raison : une image chargee depuis un autre domaine « teinte » la toile, et
   la toile teintee refuse ensuite de produire le fichier. Verifie de trois
   facons le 7 septembre 2026. Des traces ecrits dans le fichier ne
   dependent d aucun serveur et ne teintent rien.

   LES POLICES SONT DES PILES SYSTEME, PAS DES POLICES TELECHARGEES. Raison :
   une toile ne peut pas dessiner avec une police qui n est pas encore
   chargee — elle retombe sur Arial en silence et le client recoit autre chose
   que ce qu il a vu. Avec des piles systeme il n y a rien a attendre, donc
   rien a rater. Consequence assumee : l export est fait sur la machine du
   client, donc ce qu il VOIT est exactement ce que l atelier RECOIT.

   LES QUATRE TABLES A MODIFIER SONT EN HAUT : POLICES, COULEURS, FORMES,
   PICTOS. Rien d autre ne devrait avoir besoin d etre touche.
*/
(function () {
  'use strict';

  function textePerso(cle, repli, params) {
    var pont = document.getElementById('scdmPersoI18n');
    var texte = (pont && pont.getAttribute('data-' + cle)) || repli;
    return texte.replace(/\{([a-z_]+)\}/g, function(mot, nom) {
      return params && Object.prototype.hasOwnProperty.call(params, nom) ? String(params[nom]) : mot;
    });
  }

  function nomOption(cle, option) {
    var famille = cle === 'fond' || cle === 'encre' ? 'couleur' : cle;
    return textePerso('option_' + famille + '_' + option.id, option.nom);
  }

  function messageBorne(cle, original) {
    var pont = document.getElementById('scdmPersoI18n');
    return pont && /^en(?:-|$)/i.test(pont.getAttribute('data-language') || '')
      ? textePerso(cle, original) : original;
  }


  /* ================================================================
     1. LES QUATRE TABLES
     ================================================================ */

  /* Des piles systeme uniquement. Voir la note en tete du fichier. */
  var POLICES = [
    { id: 'grasse',  nom: 'Grasse',   css: '"Arial Black","Arial Bold",Gadget,sans-serif', gras: false },
    { id: 'nette',   nom: 'Nette',    css: '"Helvetica Neue",Helvetica,Arial,sans-serif',  gras: true  },
    { id: 'etroite', nom: 'Étroite',  css: '"Arial Narrow",Arial,sans-serif',              gras: true  },
    { id: 'serif',   nom: 'Classique',css: 'Georgia,"Times New Roman",serif',              gras: true  },
    { id: 'machine', nom: 'Machine',  css: '"Courier New",Courier,monospace',              gras: true  }
  ];

  /* La palette de l atelier. Des aplats francs, lisibles de loin, et qui se
     produisent vraiment. On ne met pas de selecteur libre : un client qui
     choisit un beige sur un gris pale fabrique une pancarte illisible, et
     c est l atelier qui se fait reprocher le resultat. */
  var COULEURS = [
    { id: 'blanc',  nom: 'Blanc',   hex: '#FFFFFF', clair: true  },
    { id: 'noir',   nom: 'Noir',    hex: '#111111', clair: false },
    { id: 'rouge',  nom: 'Rouge',   hex: '#C8102E', clair: false },
    { id: 'orange', nom: 'Orange',  hex: '#E35205', clair: false },
    { id: 'jaune',  nom: 'Jaune',   hex: '#FFD100', clair: true  },
    { id: 'vert',   nom: 'Vert',    hex: '#00843D', clair: false },
    { id: 'bleu',   nom: 'Bleu',    hex: '#003DA5', clair: false },
    { id: 'gris',   nom: 'Gris',    hex: '#6D7278', clair: false }
  ];

  /* La forme DESSINEE sur la pancarte. Elle ne touche pas a la rangee
     « Forme » du configurateur, qui gouverne la decoupe : ce sont deux
     choses differentes et les melanger ferait payer une decoupe a quelqu un
     qui voulait seulement un coin arrondi sur son dessin. */
  var FORMES = [
    { id: 'rect',   nom: 'Rectangle' },
    { id: 'arrondi', nom: 'Coins arrondis' },
    { id: 'cercle', nom: 'Rond' },
    { id: 'losange', nom: 'Losange' }
  ];

  /* Des traces, pas des images. Chaque trace est dessine dans une boite de
     100 x 100 : le code le met a l echelle tout seul. Pour en ajouter un,
     prendre un dessin au trait, le ramener dans une boite de 100 x 100, et
     coller la chaine « d » ici. */
  var PICTOS = [
    { id: 'aucun', nom: 'Aucun', d: '' },
    { id: 'interdit', nom: 'Interdiction',
      d: 'M50 4A46 46 0 1 0 50 96A46 46 0 1 0 50 4ZM50 16A33.8 33.8 0 0 1 70.4 22.9L22.9 70.4A33.8 33.8 0 0 1 50 16ZM50 84A33.8 33.8 0 0 1 29.6 77.1L77.1 29.6A33.8 33.8 0 0 1 50 84Z' },
    { id: 'attention', nom: 'Attention',
      d: 'M50 6L97 88H3ZM45 38H55V64H45ZM45 70H55V80H45Z' },
    { id: 'fleche', nom: 'Flèche',
      d: 'M50 6L84 44H64V94H36V44H16Z' },
    { id: 'camera', nom: 'Caméra',
      d: 'M8 28H56V72H8ZM56 42L92 24V76L56 58ZM20 38A8 8 0 1 0 20 54A8 8 0 1 0 20 38Z' },
    { id: 'animal', nom: 'Animal',
      d: 'M22 26L34 42H66L78 26L84 54C84 74 70 88 50 88C30 88 16 74 16 54ZM38 52A5 5 0 1 0 38 62A5 5 0 1 0 38 52ZM62 52A5 5 0 1 0 62 62A5 5 0 1 0 62 52ZM44 70H56L50 78Z' },
    { id: 'feu', nom: 'Feu',
      d: 'M50 4C50 24 30 30 30 54C30 74 39 92 50 96C61 92 70 74 70 54C70 42 62 34 58 26C56 42 50 36 50 4Z' },
    { id: 'pieton', nom: 'Piéton',
      d: 'M50 4A11 11 0 1 0 50 26A11 11 0 1 0 50 4ZM38 30H62L70 62H60L58 54V96H50V68H50V96H42V54L40 62H30Z' },
    { id: 'auto', nom: 'Véhicule',
      d: 'M14 54L24 30H76L86 54V78H72V68H28V78H14ZM30 38L24 52H76L70 38ZM26 58A7 7 0 1 0 26 72A7 7 0 1 0 26 58ZM74 58A7 7 0 1 0 74 72A7 7 0 1 0 74 58Z' },
    { id: 'main', nom: 'Arrêt',
      d: 'M36 10A6 6 0 0 1 48 10V46H52V18A6 6 0 0 1 64 18V50H68V26A6 6 0 0 1 80 26V64C80 82 68 96 50 96C34 96 22 84 22 68V38A6 6 0 0 1 34 38V54H36Z' },
    { id: 'eclair', nom: 'Électricité',
      d: 'M58 4L20 56H44L38 96L80 42H54Z' },
    { id: 'cigarette', nom: 'Cigarette',
      d: 'M16 58H76V74H16ZM82 58H92V74H82ZM60 26C70 34 70 44 64 52H56C62 44 58 36 52 30ZM76 34C86 42 86 50 82 56H74C78 50 76 44 70 40Z' }
  ];

  /* ================================================================
     2. L ETAT DE L EDITEUR
     ================================================================ */

  var etat = {
    titre: '',
    texte: '',
    bas: '',
    police: 'grasse',
    fond: 'jaune',
    encre: 'noir',
    forme: 'rect',
    picto: 'aucun',
    larg: 12,
    haut: 18
  };

  var ouvert = false;
  var bouton = null;
  var panneau = null;
  var toile = null;
  var majEnCours = false;
  var minuteurPrix = null;

  /* ================================================================
     3. PETITS OUTILS
     ================================================================ */

  function el(t, cls, txt) {
    var n = document.createElement(t);
    if (cls) n.className = cls;
    if (txt != null) n.textContent = txt;
    return n;
  }

  function trouve(table, id) {
    for (var i = 0; i < table.length; i++) { if (table[i].id === id) return table[i]; }
    return table[0];
  }

  /* Un pouce fait 25,4 mm. C est la seule conversion du fichier. */
  var MM = 25.4;
  function versMm(po) { return Number((po * MM).toPrecision(15)); }
  function versPo(mm) { return Number((mm / MM).toPrecision(15)); }

  /* Virgule decimale : on ecrit 2,67 po et non 2.67 po. */
  function nb(v) { return String(v).replace('.', ','); }

  /* Les bornes viennent de scdm-custom.js, et de nulle part ailleurs.

     ON NE MET AUCUNE VALEUR DE REPLI. Un repli est une quatrieme copie des
     memes chiffres, et une copie derive : c est deja arrive entre
     scdm-custom.js et scdm-limites.js, qui ne s entendent pas sur le petit
     cote. Si la table n est pas chargee, on ne devine pas — on dit qu on ne
     sait pas et on envoie vers la soumission. Se taire coute une soumission ;
     deviner coute une commande qu on ne peut pas honorer. */
  var MIN_DESSIN = 0.5;   /* garde-fou de DESSIN, pas une regle commerciale :
                             sous un demi-pouce il n y a plus rien a montrer
                             a l ecran. */

  function bornes() {
    var C = window.SCDM_CUSTOM;
    if (!C || typeof C.LONGUEUR_MAX !== 'number') return null;
    return {
      min: typeof C.MIN_COTE === 'number' ? C.MIN_COTE : MIN_DESSIN,
      longMax: C.LONGUEUR_MAX,
      msgGrand: C.MSG_TROP_GRAND || textePerso('too_large', "Cette grandeur sort de la grille. Demandez une soumission."),
      msgPetit: C.MSG_TROP_PETIT || textePerso('too_small', "Cette grandeur est trop petite.")
    };
  }

  /* ================================================================
     LES BORNES : POURQUOI ON N EN RECOPIE PRESQUE AUCUNE
     ================================================================
     Il existe DEJA deux tables de bornes dans le site, et elles ne disent
     pas la meme chose (constate le 11 septembre 2026) :

       assets/scdm-custom.js   LARGEUR_MAX 52 po   (ce qu on AFFICHE)
       assets/scdm-limites.js  MAX_PETIT   50 po   (ce qui BLOQUE le panier)

     Deux pouces d ecart. Une pancarte dont le petit cote fait 51 po
     afficherait donc un prix ici et serait refusee au panier ensuite —
     exactement le defaut qu on cherche a eviter. Et scdm-limites.js
     n expose RIEN : ses bornes sont enfermees dans sa fonction.

     En ecrire une TROISIEME copie ici aggraverait le probleme. On fait donc
     autrement :

       1. On ne verifie soi-meme que ce qui ne peut pas deriver : le cote
          minimum, et la longueur maximum (240 po, identique dans les deux
          tables).
       2. Pour tout le reste, ON LIT LE VERDICT DU CONFIGURATEUR, qui est la
          seule source de verite : le bouton d ajout porte aria-disabled et
          la classe « scdm-hors-limite » quand le format ne passe pas, et la
          boite #scdmLimite porte le message a afficher.

     Resultat : le jour ou quelqu un change une borne dans scdm-limites.js,
     cet editeur suit tout seul. Il n y a rien a mettre a jour ici.

     A NE PAS FAIRE : recopier MAX_PETIT, AIRE_MAX_SOUPLE ou le calcul de
     surface. La surface de 1 296 po2 ne s applique QUE sans support rigide
     — la recopier sans cette condition ferait refuser un panneau qui passe.
  */

  /* Les deux seules verifications qu on fait soi-meme. */
  function refus(L, H) {
    var b = bornes();
    if (!b) return textePerso('limits_unavailable', "Les limites de format ne sont pas chargées. Rechargez la page, ou demandez une soumission.");
    if (Math.min(L, H) < b.min) return messageBorne('too_small', b.msgPetit);
    if (Math.max(L, H) > b.longMax) return messageBorne('too_large', b.msgGrand);
    return '';
  }

  /* Le verdict du configurateur, lu sur ses propres marqueurs.
     Rend { bloque: bool, msg: chaine }. Silencieux s il n est pas la. */
  function verdictDom() {
    var out = { bloque: false, msg: '' };
    var ajout = document.getElementById('scdmAjouter');
    if (ajout) {
      var attenteVisuel = false;
      var V = window.SCDM_VIERGE;
      if (ajout.classList.contains('scdm-attente') &&
          /(?:^|\s)scdmManqueMsg(?:\s|$)/.test(ajout.getAttribute('aria-describedby') || '') &&
          V && typeof V.manquantsCles === 'function') {
        try {
          var manquants = V.manquantsCles();
          attenteVisuel = Array.isArray(manquants) && manquants.length === 0;
        } catch (e) { attenteVisuel = false; }
      }
      out.bloque = (ajout.getAttribute('aria-disabled') === 'true' && !attenteVisuel) ||
                   ajout.classList.contains('scdm-hors-limite');
    }
    var boite = document.getElementById('scdmLimite');
    if (boite && !boite.hidden) {
      var t = (boite.textContent || '').trim().replace(/\s+/g, ' ');
      if (t) out.msg = t;
      if (boite.classList.contains('rouge')) out.bloque = true;
    }
    return out;
  }

  /* ================================================================
     4. LE STYLE — TOUTE COULEUR EST DEFINIE POUR LES DEUX MODES
        Mode sombre par defaut ; mode clair = classe .scdm-jour sur <html>.
        Les cibles tactiles font au moins 44 px. Rien ne deborde a 380 px.
     ================================================================ */

  var CSS = [
    '.scdm-pe{--pe-fond:#0E1219;--pe-carte:#141821;--pe-bord:#262D3B;--pe-bord2:#333D4E;',
    '  --pe-texte:#EDF1F7;--pe-doux:#98A1B2;--pe-accent:#FF7A18;--pe-accent2:#FF9A4D;',
    '  --pe-ok:#1D3A2A;--pe-okb:#2E6B47;--pe-okt:#9BE3B8;',
    '  --pe-non:#2A1512;--pe-nonb:#5B2B22;--pe-nont:#F3B8AC;}',
    'html.scdm-jour .scdm-pe{--pe-fond:#FFFFFF;--pe-carte:#F4F6FA;--pe-bord:#D8DFE9;--pe-bord2:#B4BFD0;',
    '  --pe-texte:#1B2330;--pe-doux:#5A6577;--pe-accent:#C2410C;--pe-accent2:#9A3412;',
    '  --pe-ok:#E7F6ED;--pe-okb:#8CCFA8;--pe-okt:#155C34;',
    '  --pe-non:#FDECE9;--pe-nonb:#E3A99E;--pe-nont:#8A2C1B;}',

    '.scdm-pe{background:var(--pe-fond);color:var(--pe-texte);border:1px solid var(--pe-bord);',
    '  border-radius:12px;padding:16px;margin:0 0 16px;max-width:100%;box-sizing:border-box;}',
    '.scdm-pe *{box-sizing:border-box;}',
    '.scdm-pe[hidden]{display:none !important;}',
    '.scdm-pe h3{margin:0 0 4px;font-size:17px;color:var(--pe-texte);}',
    '.scdm-pe .pe-intro{margin:0 0 16px;font-size:13px;color:var(--pe-doux);}',

    '.scdm-pe .pe-grille{display:grid;grid-template-columns:minmax(0,1fr);gap:18px;}',
    '@media (min-width:860px){.scdm-pe .pe-grille{grid-template-columns:minmax(0,1fr) minmax(0,320px);}}',

    '.scdm-pe .pe-vue{background:var(--pe-carte);border:1px solid var(--pe-bord);border-radius:10px;',
    '  padding:14px;display:flex;flex-direction:column;gap:12px;min-width:0;}',
    '.scdm-pe canvas{display:block;width:100%;height:auto;max-width:100%;border-radius:6px;}',

    '.scdm-pe .pe-champ{display:block;margin:0 0 12px;min-width:0;}',
    '.scdm-pe .pe-champ > span{display:block;font-size:12.5px;color:var(--pe-doux);margin:0 0 5px;}',
    '.scdm-pe input[type=text],.scdm-pe input[type=number]{width:100%;min-height:44px;padding:10px 12px;',
    '  border-radius:8px;border:1px solid var(--pe-bord2);background:var(--pe-carte);',
    '  color:var(--pe-texte);font:inherit;font-size:15px;}',
    '.scdm-pe input:focus-visible{outline:2px solid var(--pe-accent);outline-offset:1px;}',

    '.scdm-pe .pe-rangee{display:flex;flex-wrap:wrap;gap:8px;margin:0 0 14px;}',
    '.scdm-pe .pe-opt{min-height:44px;min-width:44px;padding:8px 14px;border-radius:99px;',
    '  border:1px solid var(--pe-bord2);background:var(--pe-carte);color:var(--pe-texte);',
    '  font:inherit;font-size:13px;cursor:pointer;display:inline-flex;align-items:center;gap:7px;}',
    '.scdm-pe .pe-opt:hover{border-color:var(--pe-accent);color:var(--pe-accent2);}',
    '.scdm-pe .pe-opt:focus-visible{outline:2px solid var(--pe-accent);outline-offset:2px;}',
    '.scdm-pe .pe-opt[aria-pressed=true]{background:var(--pe-accent);border-color:var(--pe-accent);',
    '  color:#141821;font-weight:600;}',
    'html.scdm-jour .scdm-pe .pe-opt[aria-pressed=true]{color:#FFFFFF;}',
    '.scdm-pe .pe-pastille{width:20px;height:20px;border-radius:50%;border:1px solid var(--pe-bord2);',
    '  display:inline-block;flex:0 0 auto;}',

    '.scdm-pe .pe-deux{display:flex;gap:10px;flex-wrap:wrap;}',
    '.scdm-pe .pe-deux > *{flex:1 1 120px;min-width:0;}',

    '.scdm-pe .pe-prix{background:var(--pe-carte);border:1px solid var(--pe-bord);border-radius:10px;',
    '  padding:13px 14px;}',
    '.scdm-pe .pe-prix .pe-total{font-size:22px;font-weight:700;color:var(--pe-texte);line-height:1.2;}',
    '.scdm-pe .pe-prix .pe-unit{font-size:12.5px;color:var(--pe-doux);margin-top:3px;}',
    '.scdm-pe .pe-prix .pe-src{font-size:11.5px;color:var(--pe-doux);margin-top:7px;}',

    '.scdm-pe .pe-avis{margin:10px 0 0;padding:10px 12px;border-radius:8px;font-size:13px;',
    '  background:var(--pe-non);border:1px solid var(--pe-nonb);color:var(--pe-nont);}',
    '.scdm-pe .pe-avis[hidden]{display:none !important;}',
    '.scdm-pe .pe-bien{background:var(--pe-ok);border-color:var(--pe-okb);color:var(--pe-okt);}',

    '.scdm-pe .pe-envoi{width:100%;min-height:48px;margin:14px 0 0;padding:12px 18px;border-radius:99px;',
    '  border:0;background:var(--pe-accent);color:#141821;font:inherit;font-size:15px;font-weight:700;',
    '  cursor:pointer;}',
    'html.scdm-jour .scdm-pe .pe-envoi{color:#FFFFFF;}',
    '.scdm-pe .pe-envoi:hover{background:var(--pe-accent2);}',
    '.scdm-pe .pe-envoi:disabled{opacity:.45;cursor:not-allowed;}',
    '.scdm-pe .pe-note{margin:10px 0 0;font-size:11.5px;color:var(--pe-doux);}'
  ].join('\n');

  function poserStyle() {
    if (document.getElementById('scdmPersoStyle')) return;
    var s = document.createElement('style');
    s.id = 'scdmPersoStyle';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  /* ================================================================
     5. LE DESSIN
        UNE SEULE routine de dessin, appelee deux fois : une fois pour
        l apercu a l ecran, une fois pour le fichier. C est la seule facon
        d etre sur que ce que le client voit est ce qu il recoit.
        « ech » est le nombre de points par pouce du rendu en cours.
     ================================================================ */

  function cheminForme(ctx, forme, L, H) {
    ctx.beginPath();
    if (forme === 'cercle') {
      ctx.ellipse(L / 2, H / 2, L / 2, H / 2, 0, 0, Math.PI * 2);
    } else if (forme === 'losange') {
      ctx.moveTo(L / 2, 0); ctx.lineTo(L, H / 2); ctx.lineTo(L / 2, H); ctx.lineTo(0, H / 2);
      ctx.closePath();
    } else if (forme === 'arrondi') {
      var r = Math.min(L, H) * 0.12;
      ctx.moveTo(r, 0);
      ctx.lineTo(L - r, 0); ctx.quadraticCurveTo(L, 0, L, r);
      ctx.lineTo(L, H - r); ctx.quadraticCurveTo(L, H, L - r, H);
      ctx.lineTo(r, H); ctx.quadraticCurveTo(0, H, 0, H - r);
      ctx.lineTo(0, r); ctx.quadraticCurveTo(0, 0, r, 0);
      ctx.closePath();
    } else {
      ctx.rect(0, 0, L, H);
    }
  }

  /* Coupe un texte en lignes qui tiennent dans la largeur donnee.
     Un mot plus long que la ligne n est PAS coupe : il deborderait moins
     laidement en reduisant le corps, ce dont ajuster() se charge. */
  function couper(ctx, texte, largeur) {
    var mots = String(texte).split(/\s+/), lignes = [], courante = '';
    for (var i = 0; i < mots.length; i++) {
      if (!mots[i]) continue;
      var essai = courante ? courante + ' ' + mots[i] : mots[i];
      if (ctx.measureText(essai).width > largeur && courante) {
        lignes.push(courante); courante = mots[i];
      } else { courante = essai; }
    }
    if (courante) lignes.push(courante);
    return lignes;
  }

  /* MESURE un bloc de texte sans le dessiner : reduit le corps jusqu a ce que
     ca tienne dans la hauteur donnee, et rend de quoi le peindre ensuite.

     On mesure TOUT avant de peindre QUOI QUE CE SOIT. C est ce qui permet de
     centrer le contenu dans la pancarte : en peignant au fil de l eau, on ne
     connait la hauteur totale qu une fois qu il est trop tard, et le texte se
     retrouve colle en haut avec du vide dessous. */
  function ajuster(ctx, texte, L, hMax, corps, pileCss, gras) {
    if (!texte) return null;
    var c = corps;
    for (var garde = 0; garde < 80; garde++) {
      ctx.font = (gras ? '700 ' : '') + c + 'px ' + pileCss;
      var lignes = couper(ctx, texte, L);
      var h = lignes.length * c * 1.18;

      /* ON VERIFIE AUSSI LA LARGEUR, et pas seulement la hauteur.
         couper() ne coupe jamais AU MILIEU d un mot : un mot unique plus
         large que la zone ressort donc sur une seule ligne, la hauteur tient,
         et le mot depasse du dessin. Vu a l image le 11 septembre 2026 —
         « ATTENTION » sortait des deux pointes d un losange. La seule sortie
         propre est de reduire le corps jusqu a ce que la ligne la plus large
         rentre. */
      var large = 0;
      for (var i = 0; i < lignes.length; i++) {
        var w = ctx.measureText(lignes[i]).width;
        if (w > large) large = w;
      }

      if ((h <= hMax && large <= L) || c <= 6) {
        return { corps: c, lignes: lignes, h: h, gras: gras, css: pileCss };
      }
      c = c * 0.92;
    }
    return null;
  }

  function peindreFit(ctx, fit, x, y, L) {
    if (!fit) return 0;
    ctx.font = (fit.gras ? '700 ' : '') + fit.corps + 'px ' + fit.css;
    var yy = y + fit.corps * 0.92;
    for (var i = 0; i < fit.lignes.length; i++) {
      ctx.fillText(fit.lignes[i], x + L / 2, yy);
      yy += fit.corps * 1.18;
    }
    return fit.h;
  }

  /* LE REMPLISSAGE EST EN « EVENODD », ET CE N EST PAS UN DETAIL.
     Avec la regle par defaut, les creux d un pictogramme se remplissent au
     lieu de se percer : le point d exclamation du triangle « Attention »
     disparaissait purement et simplement, et on livrait un triangle plein.
     Verifie a l image le 11 septembre 2026, sur les douze pictogrammes.
     NE PAS REVENIR a la regle par defaut sans regarder le resultat. */
  function dessinerPicto(ctx, d, x, y, taille, couleur) {
    if (!d || typeof window.Path2D !== 'function') return;
    ctx.save();
    ctx.translate(x, y);
    ctx.scale(taille / 100, taille / 100);
    ctx.fillStyle = couleur;
    try { ctx.fill(new window.Path2D(d), 'evenodd'); } catch (e) {}
    ctx.restore();
  }

  /* ppp = points par pouce du rendu. L et H sont en POUCES. */
  function dessiner(ctx, L, H, ppp) {
    var px = L * ppp, py = H * ppp;
    var fond = trouve(COULEURS, etat.fond);
    var encre = trouve(COULEURS, etat.encre);
    var pol = trouve(POLICES, etat.police);
    var pic = trouve(PICTOS, etat.picto);

    ctx.save();
    ctx.clearRect(0, 0, px, py);

    /* Le fond suit la forme choisie. Hors de la forme, on laisse transparent :
       l atelier verra tout de suite ou passe le bord. */
    cheminForme(ctx, etat.forme, px, py);
    ctx.fillStyle = fond.hex;
    ctx.fill();

    /* Un filet de la couleur d encre, pour que le blanc sur blanc reste
       visible et que le bord de la pancarte se lise. */
    ctx.lineWidth = Math.max(1, ppp * 0.03);
    ctx.strokeStyle = encre.hex;
    ctx.stroke();

    /* On ecrit a l interieur, avec une marge franche. */
    var m = Math.min(px, py) * 0.09;
    var zx = m, zy = m, zL = px - m * 2, zH = py - m * 2;
    if (etat.forme === 'cercle' || etat.forme === 'losange') {
      zx = px * 0.20; zy = py * 0.20; zL = px * 0.60; zH = py * 0.60;
    }

    ctx.fillStyle = encre.hex;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'alphabetic';

    /* --- 1. ON MESURE TOUT --- */
    var ecart = zH * 0.035;
    var t = pic.d ? Math.min(zL * 0.42, zH * 0.30) : 0;

    var fitT = ajuster(ctx, etat.titre, zL, zH * 0.38, zH * 0.26, pol.css, true);

    /* LE TITRE NE DOIT JAMAIS ETRE PLUS PETIT QUE LE TEXTE. Sans ce plafond,
       un titre long se reduit pour tenir sur deux lignes pendant que le texte
       garde son corps de depart, et la pancarte annonce son sous-titre en
       plus gros que son titre. Vu a l image le 11 septembre 2026. */
    /* Sans titre, le texte EST le titre : c est le cas « j ecris juste un
       mot », qui est la raison d etre de cet onglet. On le laisse grandir. */
    var plafondTexte = fitT ? fitT.corps * 0.80 : zH * 0.34;
    var fitX = ajuster(ctx, etat.texte, zL, fitT ? zH * 0.40 : zH * 0.62, plafondTexte, pol.css, pol.gras);

    var plafondBas = zH * 0.09;
    if (fitX) plafondBas = Math.min(plafondBas, fitX.corps * 0.65);
    else if (fitT) plafondBas = Math.min(plafondBas, fitT.corps * 0.50);
    var fitB = ajuster(ctx, etat.bas, zL, zH * 0.16, plafondBas, pol.css, false);

    var total = 0;
    if (t) total += t + ecart;
    if (fitT) total += fitT.h + ecart;
    if (fitX) total += fitX.h + ecart;
    if (fitB) total += fitB.h;
    else if (total > 0) total -= ecart;   /* pas d ecart apres le dernier bloc */

    /* --- 2. ON CENTRE, PUIS ON PEINT --- */
    var y = zy + Math.max(0, (zH - total) / 2);

    if (t) {
      dessinerPicto(ctx, pic.d, zx + (zL - t) / 2, y, t, encre.hex);
      y += t + ecart;
    }
    if (fitT) { y += peindreFit(ctx, fitT, zx, y, zL) + ecart; }
    if (fitX) { y += peindreFit(ctx, fitX, zx, y, zL) + ecart; }
    if (fitB) { peindreFit(ctx, fitB, zx, y, zL); }

    ctx.restore();
  }

  /* ================================================================
     6. L APERCU
     ================================================================ */

  var APERCU_L = 520;   /* largeur du rendu d apercu, en points */

  function rafraichirApercu() {
    if (!toile) return;
    var L = etat.larg, H = etat.haut;
    if (!(L > 0) || !(H > 0)) return;
    var ppp = APERCU_L / L;
    var hp = Math.round(H * ppp);
    /* On borne la hauteur pour qu une banderole de 240 po ne fasse pas une
       toile de 30 000 points de haut. */
    if (hp > 900) { ppp = 900 / H; hp = 900; }
    toile.width = Math.round(L * ppp);
    toile.height = hp;
    var ctx = toile.getContext('2d');
    if (!ctx) return;
    dessiner(ctx, L, H, ppp);
  }

  /* ================================================================
     7. LE PRIX — ON LIT, ON N INVENTE RIEN
        Le configurateur n emet aucun evenement quand son prix change
        (verifie le 11 septembre 2026 : aucun dispatchEvent dans scdm.js).
        On relit donc a intervalle pendant que l editeur est ouvert, et
        seulement pendant ce temps-la.
     ================================================================ */

  function argent(v) {
    if (typeof v !== 'number' || !isFinite(v)) return null;
    try {
      return v.toLocaleString('fr-CA', { style: 'currency', currency: 'CAD' });
    } catch (e) {
      return nb(v.toFixed(2)) + ' $';
    }
  }

  function majPrix() {
    if (!panneau) return;
    var zTotal = panneau.querySelector('[data-pe=total]');
    var zUnit = panneau.querySelector('[data-pe=unit]');
    var zAvis = panneau.querySelector('[data-pe=avis]');
    var bEnvoi = panneau.querySelector('[data-pe=envoi]');
    if (!zTotal) return;

    /* 1. Notre propre borne de dimension, lue dans scdm-custom.js. */
    var mot = refus(etat.larg, etat.haut);
    if (mot) {
      zTotal.textContent = textePerso('price_on_request', "Prix sur demande");
      if (zUnit) zUnit.textContent = '';
      if (zAvis) { zAvis.textContent = mot; zAvis.hidden = false; zAvis.classList.remove('pe-bien'); }
      if (bEnvoi) bEnvoi.disabled = true;
      return;
    }
    if (bEnvoi) bEnvoi.disabled = false;

    /* 2. Le moteur du configurateur. S il n est pas la, on le dit. */
    var S = window.SCDM;
    if (!S || typeof S.calcul !== 'function') {
      zTotal.textContent = '—';
      if (zUnit) zUnit.textContent = textePerso('price_in_config', "Le prix s’affichera dans le configurateur.");
      if (zAvis) zAvis.hidden = true;
      return;
    }

    var v = null;
    if (typeof S.valide === 'function') {
      try { v = S.valide(); } catch (e) { v = null; }
    }

    var r = null;
    try { r = S.calcul(); } catch (e) { r = null; }

    if (!r || typeof r.total !== 'number' || !isFinite(r.total) || r.total <= 0) {
      zTotal.textContent = '—';
      if (zUnit) zUnit.textContent = textePerso('choose_material_quantity', "Choisissez la matière et la quantité dans le configurateur, en haut de la page.");
      if (zAvis) zAvis.hidden = true;
      return;
    }

    zTotal.textContent = argent(r.total) || '—';
    if (zUnit) {
      var q = r.qte > 0 ? r.qte : 1;
      var u = argent(r.total / q);
      zUnit.textContent = q > 1 && u ? textePerso('copies_each', '{count} exemplaires — {price} chacun', {count:q, price:u}) : textePerso('single_copy', "pour 1 exemplaire");
    }

    /* Le dernier mot revient au configurateur : d abord sa propre validation,
       puis les marqueurs que scdm-limites.js pose sur le bouton d ajout. On
       ne reproduit aucune de ses regles, on lit son resultat. */
    var d = verdictDom();
    var message = '';
    var bloque = false;

    if (v && v.ok === false && v.msg) { message = v.msg; bloque = !!v.devis; }
    if (d.msg) message = d.msg;
    if (d.bloque) bloque = true;

    if (bloque) {
      zTotal.textContent = textePerso('price_on_request', "Prix sur demande");
      if (zUnit) zUnit.textContent = '';
    }

    if (zAvis) {
      if (message) {
        zAvis.textContent = message;
        zAvis.hidden = false;
        zAvis.classList.remove('pe-bien');
      } else {
        zAvis.hidden = true;
      }
    }
    if (bEnvoi) bEnvoi.disabled = bloque;
  }

  function veillerPrix(oui) {
    if (minuteurPrix) { clearInterval(minuteurPrix); minuteurPrix = null; }
    if (oui) minuteurPrix = setInterval(majPrix, 700);
  }

  /* ================================================================
     8. POSER LA GRANDEUR DANS LE CONFIGURATEUR
        On n ecrit JAMAIS dans window.SCDM.etat : on pose la valeur sur le
        champ et on emet un « input » ordinaire, exactement comme un doigt
        sur un clavier. C est le seul chemin que le configurateur connait.
     ================================================================ */

  function poserChamp(id, valeur) {
    var c = document.getElementById(id);
    if (!c) return false;
    c.value = String(valeur);
    try {
      c.dispatchEvent(new Event('input', { bubbles: true }));
      c.dispatchEvent(new Event('change', { bubbles: true }));
    } catch (e) { return false; }
    return true;
  }

  function poserDimensions() {
    var sel = document.getElementById('scdmTaille');
    if (sel) {
      var trouveCustom = false;
      for (var i = 0; i < sel.options.length; i++) {
        if (sel.options[i].value === 'custom') { trouveCustom = true; break; }
      }
      if (trouveCustom && sel.value !== 'custom') {
        sel.value = 'custom';
        try { sel.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {}
      }
    }
    poserChamp('scdmLargeur', etat.larg);
    poserChamp('scdmHauteur', etat.haut);
  }

  /* ================================================================
     9. L ENVOI
        On fabrique un PNG a 300 points par pouce — la resolution
        d impression — et on le depose par window.SCDM.chargerFichier(), la
        meme porte que le champ de televersement et que le glisser-deposer.

        LE NOM COMMENCE PAR « design-scdm-perso- » ET NON « modele-scdm- ».
        Raison : scdm-modeles.js ecrit « Modele de la bibliotheque — fichier
        d impression prepare par l atelier » sous tout fichier dont le nom
        commence par « modele-scdm- ». Ce serait faux ici : le dessin vient du
        client, pas de l atelier.
     ================================================================ */

  var PPP = 300;            /* points par pouce du fichier produit */
  var PIXELS_MAX = 40e6;    /* au-dela, un telephone n y arrive pas */
  var PPP_MIN = 150;        /* mais jamais sous cette resolution */

  function pppExport(L, H) {
    var p = PPP;
    while (L * p * H * p > PIXELS_MAX && p > PPP_MIN) { p -= 25; }
    return Math.max(PPP_MIN, p);
  }

  function resume(affichage) {
    var pol = trouve(POLICES, etat.police);
    var pic = trouve(PICTOS, etat.picto);
    var f = trouve(FORMES, etat.forme);
    function phrase(cle, repli, params) {
      if (affichage) return textePerso(cle, repli, params);
      return repli.replace(/\{([a-z_]+)\}/g, function(mot, nom) { return String(params[nom]); });
    }
    var bits = [
      phrase('summary_size', 'Grandeur : {width} × {height} po ({width_mm} × {height_mm} mm)', {width:nb(etat.larg), height:nb(etat.haut), width_mm:versMm(etat.larg), height_mm:versMm(etat.haut)}),
      phrase('summary_shape', 'Forme : {value}', {value:affichage ? nomOption('forme', f) : f.nom}),
      phrase('summary_font', 'Police : {value}', {value:affichage ? nomOption('police', pol) : pol.nom}),
      phrase('summary_background', 'Fond : {value}', {value:affichage ? nomOption('fond', trouve(COULEURS, etat.fond)) : trouve(COULEURS, etat.fond).nom}),
      phrase('summary_ink', 'Texte : {value}', {value:affichage ? nomOption('encre', trouve(COULEURS, etat.encre)) : trouve(COULEURS, etat.encre).nom})
    ];
    if (pic.d) bits.push(phrase('summary_pictogram', 'Pictogramme : {value}', {value:affichage ? nomOption('picto', pic) : pic.nom}));
    if (etat.titre) bits.push(phrase('summary_title', 'Titre : {value}', {value:etat.titre}));
    if (etat.texte) bits.push(phrase('summary_text', 'Texte : {value}', {value:etat.texte}));
    if (etat.bas) bits.push(phrase('summary_bottom', 'Bas de pancarte : {value}', {value:etat.bas}));
    return bits.join(' · ');
  }

  function envoyer() {
    var bEnvoi = panneau ? panneau.querySelector('[data-pe=envoi]') : null;
    var zAvis = panneau ? panneau.querySelector('[data-pe=avis]') : null;

    var mot = refus(etat.larg, etat.haut);
    var d = verdictDom();
    if (!mot && d.bloque) mot = d.msg || textePerso('too_large', "Cette grandeur sort de la grille. Demandez une soumission.");
    if (mot) {
      if (zAvis) { zAvis.textContent = mot; zAvis.hidden = false; zAvis.classList.remove('pe-bien'); }
      return;
    }
    if (!etat.titre && !etat.texte && !etat.bas && etat.picto === 'aucun') {
      if (zAvis) {
        zAvis.textContent = textePerso('empty_artwork', "Écrivez au moins un mot, ou choisissez un pictogramme.");
        zAvis.hidden = false;
        zAvis.classList.remove('pe-bien');
      }
      return;
    }

    if (bEnvoi) { bEnvoi.disabled = true; bEnvoi.textContent = textePerso('preparing', "Préparation…"); }

    var L = etat.larg, H = etat.haut, p = pppExport(L, H);
    var c = document.createElement('canvas');
    c.width = Math.round(L * p);
    c.height = Math.round(H * p);
    var ctx = c.getContext('2d');
    if (!ctx) {
      if (bEnvoi) { bEnvoi.disabled = false; bEnvoi.textContent = textePerso('use_design', "Utiliser ce design"); }
      return;
    }
    dessiner(ctx, L, H, p);

    c.toBlob(function (blob) {
      if (bEnvoi) { bEnvoi.disabled = false; bEnvoi.textContent = textePerso('use_design', "Utiliser ce design"); }
      if (!blob) return;
      var nom = 'design-scdm-perso-' + Date.now() + '.png';
      var fichier;
      try {
        fichier = new File([blob], nom, { type: 'image/png' });
      } catch (e) {
        fichier = blob;
        try { fichier.name = nom; } catch (e2) {}
      }

      poserDimensions();

      var pose = false;
      if (window.SCDM && typeof window.SCDM.chargerFichier === 'function') {
        try { window.SCDM.chargerFichier(fichier); pose = true; } catch (e3) { pose = false; }
      }
      if (!pose) {
        /* Filet : le champ de televersement, comme si le client l avait
           choisi lui-meme. */
        var champ = document.getElementById('scdmFichier');
        if (champ && typeof window.DataTransfer === 'function') {
          try {
            var dt = new window.DataTransfer();
            dt.items.add(fichier);
            champ.files = dt.files;
            champ.dispatchEvent(new Event('change', { bubbles: true }));
            pose = true;
          } catch (e4) { pose = false; }
        }
      }

      if (zAvis) {
        if (pose) {
          zAvis.textContent = textePerso('sent', "Design envoyé au configurateur, en haut de la page. ") + resume(true);
          zAvis.classList.add('pe-bien');
        } else {
          zAvis.textContent = textePerso('send_failed', "Le design n’a pas pu être envoyé au configurateur. Réessayez, ou demandez une soumission.");
          zAvis.classList.remove('pe-bien');
        }
        zAvis.hidden = false;
      }

      if (pose) {
        var cfg = document.getElementById('scdmConfig') || document.getElementById('configurateur');
        if (cfg && cfg.scrollIntoView) cfg.scrollIntoView({ behavior: 'smooth', block: 'start' });
        setTimeout(majPrix, 250);
      }
    }, 'image/png');
  }

  /* ================================================================
     10. LA CONSTRUCTION DU PANNEAU
     ================================================================ */

  function champTexte(libelle, cle, exemple) {
    var lab = el('label', 'pe-champ');
    lab.appendChild(el('span', '', libelle));
    var i = document.createElement('input');
    i.type = 'text';
    i.value = etat[cle];
    i.maxLength = 60;
    if (exemple) i.placeholder = exemple;
    i.addEventListener('input', function () {
      etat[cle] = i.value;
      rafraichirApercu();
    });
    lab.appendChild(i);
    return lab;
  }

  function rangeeOptions(libelle, table, cle, avecPastille, apres) {
    var bloc0 = el('div', 'pe-champ');
    bloc0.appendChild(el('span', '', libelle));
    var r = el('div', 'pe-rangee');
    table.forEach(function (o) {
      var b = el('button', 'pe-opt');
      b.type = 'button';
      b.setAttribute('aria-pressed', etat[cle] === o.id ? 'true' : 'false');
      if (avecPastille) {
        var p = el('span', 'pe-pastille');
        p.style.background = o.hex;
        b.appendChild(p);
      }
      b.appendChild(document.createTextNode(nomOption(cle, o)));
      b.addEventListener('click', function () {
        etat[cle] = o.id;
        Array.prototype.forEach.call(r.children, function (x) { x.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', 'true');
        rafraichirApercu();
        if (apres) apres();
      });
      r.appendChild(b);
    });
    bloc0.appendChild(r);
    return bloc0;
  }

  /* Les deux champs de grandeur se recopient l un l autre. Seuls les POUCES
     partent vers le configurateur : il ne connait que cette unite, et lui en
     presenter une autre demanderait de toucher a scdm.js. */
  function champsGrandeur() {
    var b = bornes() || { min: MIN_DESSIN, longMax: 0 };
    var enveloppe = el('div', 'pe-champ');
    enveloppe.appendChild(el('span', '', textePerso('dimensions_heading', "Grandeur — en pouces et en millimètres")));

    function paire(cle, libelle) {
      var boite = el('div', '');
      var lp = el('label', 'pe-champ');
      lp.appendChild(el('span', '', libelle + textePerso('inch_suffix', " (po)")));
      var ip = document.createElement('input');
      ip.type = 'number'; ip.min = String(b.min); ip.step = 'any';
      if (b.longMax > 0) ip.max = String(b.longMax);
      ip.value = String(etat[cle]);

      var lm = el('label', 'pe-champ');
      lm.appendChild(el('span', '', libelle + ' (mm)'));
      var im = document.createElement('input');
      im.type = 'number'; im.min = String(versMm(b.min)); im.step = 'any';
      if (b.longMax > 0) im.max = String(versMm(b.longMax));
      im.value = String(versMm(etat[cle]));

      ip.addEventListener('input', function () {
        var v = parseFloat(ip.value);
        if (!isFinite(v) || v <= 0) return;
        etat[cle] = v;
        im.value = String(versMm(v));
        rafraichirApercu(); poserDimensions(); majPrix();
      });
      im.addEventListener('input', function () {
        var v = parseFloat(im.value);
        if (!isFinite(v) || v <= 0) return;
        etat[cle] = versPo(v);
        ip.value = String(etat[cle]);
        rafraichirApercu(); poserDimensions(); majPrix();
      });

      lp.appendChild(ip); lm.appendChild(im);
      boite.appendChild(lp); boite.appendChild(lm);
      return boite;
    }

    var deux = el('div', 'pe-deux');
    deux.appendChild(paire('larg', textePerso('width', "Largeur")));
    deux.appendChild(paire('haut', textePerso('height', "Hauteur")));
    enveloppe.appendChild(deux);
    return enveloppe;
  }

  function construire() {
    poserStyle();
    var p = el('div', 'scdm-pe');
    p.id = 'scdmPersoPanneau';
    p.hidden = true;

    var t = el('h3', '', textePerso('heading', "✏️ Écrire ma propre pancarte"));
    var i = el('p', 'pe-intro',
      textePerso('intro', "Pour écrire un mot ou deux, simplement. Pour un vrai design, passez par « Créer un design avec l’IA » ou par une demande de soumission."));
    p.appendChild(t);
    p.appendChild(i);

    var g = el('div', 'pe-grille');

    /* -- colonne de gauche : ce que le client voit -- */
    var vue = el('div', 'pe-vue');
    toile = document.createElement('canvas');
    toile.setAttribute('role', 'img');
    toile.setAttribute('aria-label', textePerso('preview', "Aperçu de votre pancarte"));
    vue.appendChild(toile);

    var prix = el('div', 'pe-prix');
    var zt = el('div', 'pe-total', '—'); zt.setAttribute('data-pe', 'total');
    var zu = el('div', 'pe-unit', ''); zu.setAttribute('data-pe', 'unit');
    var zs = el('div', 'pe-src', textePerso('price_source', "Prix calculé par le configurateur, pour la matière et la quantité choisies en haut de la page."));
    prix.appendChild(zt); prix.appendChild(zu); prix.appendChild(zs);
    vue.appendChild(prix);

    var avis = el('p', 'pe-avis', ''); avis.setAttribute('data-pe', 'avis'); avis.hidden = true;
    avis.setAttribute('role', 'status'); avis.setAttribute('aria-live', 'polite');
    vue.appendChild(avis);

    var envoi = el('button', 'pe-envoi', textePerso('use_design', "Utiliser ce design"));
    envoi.type = 'button';
    envoi.setAttribute('data-pe', 'envoi');
    envoi.addEventListener('click', envoyer);
    vue.appendChild(envoi);

    vue.appendChild(el('p', 'pe-note',
      textePerso('export_note', "Le fichier envoyé est une image. Pour du lettrage découpé ou un très grand format, demandez plutôt une soumission : l’atelier redessine le tracé proprement à partir de vos réglages.")));

    g.appendChild(vue);

    /* -- colonne de droite : les reglages -- */
    var reg = el('div', '');
    reg.appendChild(champTexte(textePerso('title', "Titre"), 'titre', textePerso('example_title', "DÉFENSE DE PASSER")));
    reg.appendChild(champTexte(textePerso('text', "Texte"), 'texte', textePerso('example_text', "Propriété privée")));
    reg.appendChild(champTexte(textePerso('bottom', "Petite ligne du bas"), 'bas', textePerso('example_bottom', "Merci de votre collaboration")));
    reg.appendChild(rangeeOptions(textePerso('font', "Police"), POLICES, 'police', false, null));
    reg.appendChild(rangeeOptions(textePerso('background', "Couleur du fond"), COULEURS, 'fond', true, null));
    reg.appendChild(rangeeOptions(textePerso('ink', "Couleur du texte"), COULEURS, 'encre', true, null));
    reg.appendChild(rangeeOptions(textePerso('shape', "Forme"), FORMES, 'forme', false, null));
    reg.appendChild(rangeeOptions(textePerso('pictogram', "Pictogramme"), PICTOS, 'picto', false, null));
    reg.appendChild(champsGrandeur());
    g.appendChild(reg);

    p.appendChild(g);
    return p;
  }

  /* ================================================================
     11. OUVRIR, FERMER, ACCROCHER LE BOUTON
     ================================================================ */

  function ancrage() {
    /* On se pose juste au-dessus de la grille de modeles : le client garde
       la rangee d onglets sous les yeux et peut ressortir d un clic. */
    return document.getElementById('scdmGrille');
  }

  function ouvrir() {
    var g = ancrage();
    if (!g || !g.parentNode) return;
    if (!panneau) panneau = construire();
    if (panneau.parentNode !== g.parentNode) g.parentNode.insertBefore(panneau, g);
    panneau.hidden = false;
    g.classList.add('scdm-cache');
    var plus = document.getElementById('scdmPlus');
    if (plus) plus.classList.add('scdm-cache');
    ouvert = true;
    if (bouton) { bouton.classList.add('on'); bouton.setAttribute('aria-expanded', 'true'); }
    rafraichirApercu();
    poserDimensions();
    majPrix();
    veillerPrix(true);
  }

  function fermer() {
    if (panneau) panneau.hidden = true;
    var g = ancrage();
    if (g) g.classList.remove('scdm-cache');
    var plus = document.getElementById('scdmPlus');
    if (plus) plus.classList.remove('scdm-cache');
    ouvert = false;
    if (bouton) { bouton.classList.remove('on'); bouton.setAttribute('aria-expanded', 'false'); }
    veillerPrix(false);
  }

  function poserBouton() {
    var rangee = document.getElementById('scdmOnglets');
    if (!rangee || document.getElementById('scdmPersoBtn')) return;

    bouton = el('button', '');
    bouton.type = 'button';
    bouton.id = 'scdmPersoBtn';
    bouton.textContent = rangee.getAttribute('data-custom_label') || '✏️ Personnalisé';
    bouton.title = rangee.getAttribute('data-custom_title') || 'Écrire ma propre pancarte';
    bouton.setAttribute('aria-expanded', ouvert ? 'true' : 'false');

    /* On copie la classe d un onglet existant pour ressembler aux autres —
       MAIS SURTOUT PAS SON data-filtre : c est l absence de cet attribut qui
       fait que rebatirOnglets() nous remet en place au lieu de nous effacer. */
    var modele = rangee.querySelector('button');
    if (modele) bouton.className = modele.className.replace(/\bon\b/, '').trim();
    if (ouvert) bouton.classList.add('on');

    bouton.addEventListener('click', function (e) {
      e.stopPropagation();
      if (ouvert) { fermer(); } else { ouvrir(); }
    });
    rangee.insertBefore(bouton, rangee.children[1] || null);
  }

  /* Un clic sur un VRAI onglet referme l editeur : le client a demande autre
     chose. En phase de capture, pour passer avant le filtrage du catalogue. */
  function ecouterRangee() {
    var rangee = document.getElementById('scdmOnglets');
    if (!rangee || rangee.getAttribute('data-pe-ecoute') === '1') return;
    rangee.setAttribute('data-pe-ecoute', '1');
    rangee.addEventListener('click', function (e) {
      var cible = e.target.closest ? e.target.closest('button') : null;
      if (!cible || cible.id === 'scdmPersoBtn') return;
      if (ouvert) fermer();
    }, true);
  }

  function demarrer() {
    if (!document.getElementById('scdmOnglets')) return false;
    poserBouton();
    ecouterRangee();
    return true;
  }

  /* La rangee d onglets est reconstruite quand les 3 441 modeles arrivent.
     On remet le bouton si jamais il disparait — ceinture (l observateur) et
     bretelles (le minuteur), parce qu un bouton d onglet absent est une
     promesse qui disparait sous les yeux du client. */
  function veiller() {
    if (!demarrer()) {
      /* La section du catalogue n est pas encore la : on attend. */
      var essais = 0;
      var attente = setInterval(function () {
        essais++;
        if (demarrer() || essais > 60) clearInterval(attente);
      }, 300);
    }
    if (window.MutationObserver) {
      var obs = new MutationObserver(function () {
        if (!document.getElementById('scdmPersoBtn')) poserBouton();
        ecouterRangee();
      });
      obs.observe(document.documentElement, { childList: true, subtree: true });
    }
    setInterval(function () {
      if (!document.getElementById('scdmPersoBtn')) poserBouton();
    }, 1200);

    document.addEventListener('scdm:catalogue-pret', function () {
      if (!document.getElementById('scdmPersoBtn')) poserBouton();
      ecouterRangee();
    });
  }

  /* On demarre TOUT DE SUITE, sans attendre DOMContentLoaded. Le fichier est
     charge en « defer », donc la page est deja analysee quand il s execute ;
     et si la section du catalogue n est pas encore la, veiller() reessaie
     tout seul pendant dix-huit secondes, puis l observateur prend le relais.
     Attendre un evenement de plus, c est un onglet qui manque a l ecran
     pendant que le catalogue se charge. */
  veiller();

  /* Une seule porte de sortie, pour les essais. On n expose aucun calcul. */
  window.SCDM_PERSO = {
    ouvrir: ouvrir,
    fermer: fermer,
    etat: etat,
    tables: { POLICES: POLICES, COULEURS: COULEURS, FORMES: FORMES, PICTOS: PICTOS },
    resume: resume,
    refus: refus,
    versMm: versMm,
    versPo: versPo
  };
})();
